export default {
    category: {
        cta: "Visualizza i prodotti"
    }
}